import { render } from "./Articles.vue?vue&type=template&id=1eacff06&ts=true"
import script from "./Articles.vue?vue&type=script&lang=ts"
export * from "./Articles.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__